(function () {
  var root = document.getElementById('tk-chat');
  if (!root || root.dataset.tkChatReady) return;
  root.dataset.tkChatReady = '1';

  var MIN_TOKEN_AGE = 2600;
  var MAX_TOKEN_AGE = 100 * 60 * 1000;
  var MAX_LOG = 40;
  var MAX_CONVS = 20;
  var RECENT = 3;
  var STATUS_TTL = 10 * 60 * 1000;
  var LIVE_POLL = 2500;
  var LIVE_POLL_HIDDEN = 8000;
  var TYPING_DELAY = 700;
  var TK_CHAT_VERSION = '1.4.1';
  var ORDER_PREFIX = '';
  var NUDGE_SNOOZE = 3 * 24 * 60 * 60 * 1000;
  var KEY_STATE = 'tk_chat_v2';
  var KEY_OPEN = 'tk_chat_open';
  var KEY_STATUS = 'tk_chat_status';
  var KEY_DRAFT = 'tk_chat_draft';
  var KEY_NUDGE_SEEN = 'tk_chat_nudge_seen';
  var KEY_NUDGE_OFF = 'tk_chat_nudge_off';
  var LEGACY_SESSION = 'tk_chat_session';
  var LEGACY_LOG = 'tk_chat_log';

  var endpoint = (root.dataset.endpoint || '').replace(/\/+$/, '');
  var shop = root.dataset.shop || '';
  var locale = root.dataset.locale || 'cs';
  var country = root.dataset.country || '';
  var addressForm = root.dataset.address === 'informal' ? 'informal' : 'formal';
  var rootPath = (root.dataset.rootPath || '/').replace(/\/+$/, '');
  var rootUrl = location.origin + rootPath;
  var strings = readJson('[data-tk-chat-strings]');
  var page = readJson('[data-tk-chat-page]');

  var launch = root.querySelector('[data-tk-chat-open]');
  var badge = root.querySelector('[data-tk-chat-badge]');
  var panel = root.querySelector('#tk-chat-panel');
  var log = root.querySelector('[data-tk-chat-log]');
  var list = root.querySelector('[data-tk-chat-list]');
  var views = {
    home: root.querySelector('[data-tk-chat-view="home"]'),
    list: root.querySelector('[data-tk-chat-view="list"]'),
    chat: root.querySelector('[data-tk-chat-view="chat"]')
  };
  var ctxBox = root.querySelector('[data-tk-chat-ctx]');
  var tilesBox = root.querySelector('[data-tk-chat-tiles]');
  var faqBox = root.querySelector('[data-tk-chat-faq]');
  var faqToggle = root.querySelector('[data-tk-chat-faqtoggle]');
  var recentBox = root.querySelector('[data-tk-chat-recent]');
  var recentList = root.querySelector('[data-tk-chat-recent-list]');
  var allBtn = root.querySelector('[data-tk-chat-all]');
  var tray = root.querySelector('[data-tk-chat-tray]');
  var trayBtn = root.querySelector('[data-tk-chat-traybtn]');
  var downBtn = root.querySelector('[data-tk-chat-down]');
  var form = root.querySelector('[data-tk-chat-form]');
  var input = root.querySelector('[data-tk-chat-input]');
  var sendBtn = root.querySelector('[data-tk-chat-send]');
  var closeBtn = root.querySelector('[data-tk-chat-close]');
  var backBtn = root.querySelector('[data-tk-chat-back]');
  var endBtn = root.querySelector('[data-tk-chat-end]');
  var newBtns = root.querySelectorAll('[data-tk-chat-new]');

  var ICONS = {
    choose: 'M12 3l1.9 5.6L19.5 10l-5.6 1.9L12 17.5l-1.9-5.6L4.5 10l5.6-1.9zM19 17l.8 2.2L22 20l-2.2.8L19 23l-.8-2.2L16 20l2.2-.8z',
    shipping: 'M3 7h11v9H3zM14 10h4l3 3v3h-7M6.5 19a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6zM17.5 19a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6z',
    order: 'M3.5 8L12 3.5 20.5 8v8L12 20.5 3.5 16zM3.5 8L12 12.5 20.5 8M12 12.5v8',
    returns: 'M4 12a8 8 0 1 0 2.3-5.7M4 4v5h5',
    discreet: 'M12 3l7 3v5.6c0 4.2-2.9 7.7-7 9.4-4.1-1.7-7-5.2-7-9.4V6zM9.2 11.8l2 2 3.6-3.6',
    care: 'M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11z',
    product: 'M21 11.5a8.4 8.4 0 0 1-9 8.4L3 21l1.1-3.3A8.4 8.4 0 1 1 21 11.5zM9.6 9.5a2.4 2.4 0 0 1 4.7.7c0 1.6-2.3 2.2-2.3 2.2M12 16.2h.01',
    collection: 'M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z',
    human: 'M12 12.5a4.25 4.25 0 1 0 0-8.5 4.25 4.25 0 0 0 0 8.5zM4.5 20.5a7.5 7.5 0 0 1 15 0',
    mail: 'M3.5 6.5h17v11h-17zM3.5 7l8.5 6.5L20.5 7',
    phone: 'M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2',
    clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7v5l3 2'
  };

  var TILES = [
    { id: 'choose', q: 'tile_choose_q', follow: ['faq_1', 'faq_2', 'faq_3'] },
    { id: 'shipping', q: 'tile_shipping_q', follow: ['faq_4', 'faq_5', 'tile_discreet_q'] },
    { id: 'order', form: true },
    { id: 'returns', q: 'tile_returns_q', follow: ['faq_8', 'faq_9'] },
    { id: 'discreet', q: 'tile_discreet_q', follow: ['faq_5', 'faq_4'] },
    { id: 'care', q: 'tile_care_q', follow: ['faq_1', 'faq_10'] },
    { id: 'human', human: true, wide: true }
  ];
  var HUMAN_RE = [
    /(^|[^\p{L}])(s|so|se|na|k)\s+(člověkem|clovekem|človekom|člověka|cloveka|človeka|operátorem|operatorem|operátorom|operátora|operátorkou|operátorku|někým|nekym|niekým|živým|živou|živého|živej)(?=$|[^\p{L}])/iu,
    /(^|[^\p{L}])(talk|speak|chat|connect|reach|get|put)\s+(me\s+)?(to|with|through\s+to)?\s*(a\s+|an\s+|the\s+|some\s+)?(human|real\s+person|person|agent|someone|operator|staff|team\s+member|support)(?=$|[^\p{L}])/iu,
    /(live\s*chat|real\s+person|a\s+human|zákaznick|zakaznick|customer\s+(service|support|care)|support\s+team|zákaznícky\s+servis)/iu,
    /(telefonní\s+číslo|telefonni\s+cislo|telefónne\s+číslo|phone\s+number|váš\s+e-?mail|vas\s+e-?mail|your\s+e-?mail|kontakt\s+na\s+vás|kontakt\s+na\s+vas|kontaktní\s+údaje|kontaktné\s+údaje|contact\s+details|jak\s+vás\s+kontaktovat|ako\s+vás\s+kontaktovať|how\s+(can|do)\s+i\s+contact)/iu
  ];
  var HUMAN_SHORT_RE = /(^|[^\p{L}])(člověk|clovek|človek|člověka|operátor|operator|operátora|human|podpora|support)(?=$|[^\p{L}])/iu;
  var TOOL_STATUS = {
    search_products: 'status_search',
    get_collection_products: 'status_search',
    get_product: 'status_search',
    search_content: 'status_search',
    get_homepage_content: 'status_search',
    get_order_status: 'status_order',
    get_policy: 'status_read',
    get_page: 'status_read',
    get_article: 'status_read',
    handoff_to_human: 'status_handoff'
  };
  var FAQ = ['faq_1', 'faq_2', 'faq_3', 'faq_4', 'faq_5', 'faq_6', 'faq_8', 'faq_9'];
  var FAQ_FOLLOW = {
    faq_1: ['faq_2', 'faq_3'],
    faq_2: ['faq_1', 'faq_3'],
    faq_3: ['faq_1', 'tile_care_q'],
    faq_4: ['faq_5', 'tile_discreet_q'],
    faq_5: ['faq_4', 'tile_discreet_q'],
    faq_6: ['faq_5'],
    faq_8: ['faq_9', 'tile_returns_q'],
    faq_9: ['faq_8'],
    faq_10: ['tile_care_q']
  };

  var canStream = !!(window.ReadableStream && window.TextDecoder && window.fetch);
  var token = '';
  var issuedAt = 0;
  var sending = false;
  var typingEl = null;
  var rateEl = null;
  var state = { active: null, convs: [] };
  var conv = null;
  var view = 'home';
  var pendingFollow = null;
  var faqOpen = null;
  var subtitleEl = root.querySelector('.tk-chat__subtitle');
  var livePoll = null;
  var liveTypingTimer = null;
  var liveTypingEl = null;
  var lastTypingSent = '';
  var nudgeEl = null;
  var nudgeTimer = null;

  function readJson(sel) {
    var el = root.querySelector(sel);
    if (!el) return {};
    try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
  }

  function store(key, val) {
    try {
      if (val === null) localStorage.removeItem(key);
      else localStorage.setItem(key, typeof val === 'string' ? val : JSON.stringify(val));
    } catch (e) {}
  }

  function load(key, json) {
    try {
      var v = localStorage.getItem(key);
      if (v === null) return null;
      return json ? JSON.parse(v) : v;
    } catch (e) { return null; }
  }

  function sessionSet(key, val) {
    try {
      if (val === null) sessionStorage.removeItem(key);
      else sessionStorage.setItem(key, val);
    } catch (e) {}
  }

  function sessionGet(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }

  function randomId() {
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var out = '';
    var arr = new Uint8Array(24);
    if (window.crypto && crypto.getRandomValues) crypto.getRandomValues(arr);
    else for (var i = 0; i < arr.length; i++) arr[i] = Math.floor(Math.random() * 256);
    for (var j = 0; j < arr.length; j++) out += chars[arr[j] % chars.length];
    return out;
  }

  function loadState() {
    var s = load(KEY_STATE, true);
    if (s && Array.isArray(s.convs)) {
      state = { active: s.active || null, convs: s.convs.filter(function (c) { return c && c.id && Array.isArray(c.log); }) };
      return;
    }
    var oldId = load(LEGACY_SESSION);
    var oldLog = load(LEGACY_LOG, true);
    if (oldId && Array.isArray(oldLog) && oldLog.length) {
      state = { active: oldId, convs: [{ id: oldId, title: firstUserText(oldLog), at: Date.now(), log: oldLog }] };
      saveState();
    }
    store(LEGACY_SESSION, null);
    store(LEGACY_LOG, null);
  }

  function saveState() {
    state.convs.sort(function (a, b) { return (b.at || 0) - (a.at || 0); });
    state.convs = state.convs.slice(0, MAX_CONVS);
    state.convs.forEach(function (c) { c.log = c.log.slice(-MAX_LOG); });
    store(KEY_STATE, state);
  }

  function firstUserText(logArr) {
    for (var i = 0; i < logArr.length; i++) if (logArr[i].r === 'u' && logArr[i].t) return logArr[i].t;
    return '';
  }

  function findConv(id) {
    for (var i = 0; i < state.convs.length; i++) if (state.convs[i].id === id) return state.convs[i];
    return null;
  }

  function newConv() {
    return { id: randomId(), title: '', at: Date.now(), log: [], ended: false, w: Math.floor(Math.random() * 4), live: null, seen: 0 };
  }

  function welcomeText() {
    if (strings.home_intro) return strings.home_intro;
    var variants = [];
    for (var i = 1; i <= 4; i++) if (strings['welcome_' + i]) variants.push(strings['welcome_' + i]);
    if (!variants.length) return strings.welcome || '';
    if (conv && typeof conv.w !== 'number') conv.w = Math.floor(Math.random() * variants.length);
    return variants[((conv && conv.w) || 0) % variants.length];
  }

  function isHumanRequest(text) {
    if (text.length > 90) return false;
    if (text.length <= 40 && HUMAN_SHORT_RE.test(text)) return true;
    for (var i = 0; i < HUMAN_RE.length; i++) if (HUMAN_RE[i].test(text)) return true;
    return false;
  }

  function delay(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function fetchToken() {
    return fetch(endpoint + '/challenge', { method: 'GET', credentials: 'omit', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.ok || !d.token) throw new Error('challenge');
        token = d.token;
        issuedAt = Date.now();
        return token;
      });
  }

  function ensureToken(force) {
    var usable = token && !force && Date.now() - issuedAt < MAX_TOKEN_AGE;
    return (usable ? Promise.resolve(token) : fetchToken()).then(function (v) {
      var wait = MIN_TOKEN_AGE - (Date.now() - issuedAt);
      return wait > 0 ? delay(wait).then(function () { return v; }) : v;
    });
  }

  function scrollDown(instant) {
    if (instant) log.style.scrollBehavior = 'auto';
    log.scrollTop = log.scrollHeight;
    if (instant) log.style.scrollBehavior = '';
  }

  function scrollToStart(node) {
    if (!node) { scrollDown(); return; }
    var top = node.getBoundingClientRect().top - log.getBoundingClientRect().top + log.scrollTop;
    var pad = parseFloat(getComputedStyle(log).paddingTop) || 0;
    log.scrollTop = Math.max(0, top - pad);
  }

  function updateDown() {
    var gap = log.scrollHeight - log.scrollTop - log.clientHeight;
    downBtn.hidden = gap < 160;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function svgIcon(path, size) {
    var s = size || 22;
    var span = el('span', 'tk-chat__icon');
    span.innerHTML = '<svg width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + path + '"/></svg>';
    return span;
  }

  function fill(tpl, vars) {
    return String(tpl || '').replace(/%([A-Z]+)%/g, function (m, k) {
      return vars[k.toLowerCase()] != null ? vars[k.toLowerCase()] : '';
    });
  }

  function groupThousands(v) {
    return String(Math.round(v)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  function formatAmount(v, cur) {
    if (cur === 'CZK') return groupThousands(v) + ' Kč';
    if (cur === 'EUR') {
      var fixed = Number(v).toFixed(2);
      var parts = fixed.split('.');
      return groupThousands(parts[0]) + ',' + parts[1] + ' €';
    }
    var txt;
    try { txt = new Intl.NumberFormat(locale === 'sk' ? 'sk-SK' : locale === 'en' ? 'en-IE' : 'cs-CZ', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(v); } catch (e) { txt = String(v); }
    return cur ? txt + ' ' + cur : txt;
  }

  function formatPrice(price) {
    if (!price || price.min == null) return '';
    var txt = formatAmount(price.min, price.currency || '');
    if (price.max != null && price.max > price.min) txt = (strings.price_from || 'od') + ' ' + txt;
    return txt;
  }

  function formatDate(ts) {
    var d = new Date(ts || Date.now());
    var now = new Date();
    var same = d.toDateString() === now.toDateString();
    try {
      if (same) return d.toLocaleTimeString(locale === 'en' ? 'en-GB' : locale === 'sk' ? 'sk-SK' : 'cs-CZ', { hour: '2-digit', minute: '2-digit' });
      return d.toLocaleDateString(locale === 'en' ? 'en-GB' : locale === 'sk' ? 'sk-SK' : 'cs-CZ', { day: 'numeric', month: 'numeric' });
    } catch (e) { return ''; }
  }

  // Text z překladů theme; chybějící klíč vrací Liquid jako "translation missing: ...",
  // takže starší locale soubory bez nových klíčů spadnou na výchozí znění.
  function txt(key, fallback) {
    var v = strings[key];
    return v && String(v).indexOf('translation missing') < 0 ? v : fallback;
  }

  var CART_ICON = 'M3 4h2l2.4 10.2a1.5 1.5 0 0 0 1.5 1.1h8.6a1.5 1.5 0 0 0 1.5-1.1L21 8H6.2M9.5 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM17.5 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2z';

  function cartIcon() {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.9');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    var path = document.createElementNS(ns, 'path');
    path.setAttribute('d', CART_ICON);
    svg.appendChild(path);
    return svg;
  }

  // Sekce theme, které po vložení ukazují košík (ikona s počtem, drawer). Theme z rodiny
  // Dawn je samo vyjmenuje přes getSectionsToRender() na cart-drawer / cart-notification,
  // stejně jako je jeho formulář produktu posílá v /cart/add.js; bez nich aspoň bublina
  // #cart-icon-bubble. Ruční napojení v každém theme se ukázalo jako místo, kde se chybuje.
  function themeCartSections() {
    var host = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var list = [];
    if (host && typeof host.getSectionsToRender === 'function') {
      try { list = host.getSectionsToRender() || []; } catch (e) { list = []; }
    }
    if (!list.length && document.getElementById('cart-icon-bubble')) list = [{ id: 'cart-icon-bubble' }];
    list = list.filter(function (s) { return s && /^[A-Za-z0-9_-]+$/.test(String(s.id || '')); });
    return { host: host, list: list };
  }

  // Obsah sekcí z odpovědi /cart/add.js do stránky, jako Dawn renderContents, ale BEZ
  // otevření draweru: zákazník je v chatu a potvrzení i odkaz do košíku má na kartě.
  // Cíl, který na stránce není (notifikace produktu, jiný layout), se přeskočí.
  function renderThemeCart(theme, html) {
    if (!html || !theme.list.length) return;
    var host = theme.host;
    var insideHost = false;
    theme.list.forEach(function (s) {
      var raw = html[s.id];
      if (typeof raw !== 'string') return;
      try {
        var target = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
        if (!target) return;
        var doc = new DOMParser().parseFromString(raw, 'text/html');
        var src = doc.querySelector(s.selector || '.shopify-section');
        if (!src) return;
        target.innerHTML = src.innerHTML;
        if (host && host.contains(target)) insideHost = true;
      } catch (e) {}
    });
    if (host && host.classList.contains('is-empty')) host.classList.remove('is-empty');
    // Přepsáním obsahu draweru zmizí posluchač na ztmavené ploše vedle něj (Dawn ho věší
    // v konstruktoru na #CartDrawer-Overlay) a drawer by nešel zavřít klikem vedle. Dawn
    // ho po svém renderContents napojuje znovu, tady stejně. Jen když se obsah draweru
    // opravdu přepsal, jinak by na ploše visel posluchač dvakrát.
    if (insideHost && typeof host.close === 'function') {
      try {
        var overlay = host.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', host.close.bind(host));
      } catch (e) {}
    }
  }

  // Vložení do košíku přes Ajax API storefrontu (košík je cookie v prohlížeči, hub do něj
  // nesahá). Ikonu a drawer obnoví widget sám (sekce výš); pro theme mimo Dawn nese
  // událost tk-chat:cart-added stav košíku (cart.item_count) i HTML vyžádaných sekcí.
  function addToCart(p, btn, box) {
    if (btn.disabled) return;
    var label = btn.textContent;
    var old = box.querySelector('.tk-chat__card-err');
    if (old) old.remove();
    btn.disabled = true;
    btn.textContent = txt('adding_to_cart', 'Přidávám…');
    var theme = themeCartSections();
    var payload = { items: [{ id: Number(p.variant_id), quantity: 1 }] };
    if (theme.list.length) {
      payload.sections = theme.list.map(function (s) { return s.id; }).join(',');
      payload.sections_url = location.pathname;
    }
    fetch(rootPath + '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) {
          var err = new Error(typeof j.description === 'string' ? j.description : '');
          err.fromShop = true;
          throw err;
        }
        return j;
      });
    }).then(function (j) {
      btn.className = 'tk-chat__card-add tk-chat__card-add--done';
      btn.textContent = txt('added_to_cart', 'V košíku');
      var go = el('a', 'tk-chat__card-go', txt('go_to_cart', 'Přejít do košíku'));
      go.href = rootPath + '/cart';
      box.appendChild(go);
      renderThemeCart(theme, j.sections);
      // Dawn: ostatní komponenty (stránka košíku, doporučení) poslouchají cartUpdate přes
      // pubsub theme; formulář produktu ho vysílá po každém vložení, tady stejně.
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tk-chat', productVariantId: p.variant_id, cartData: j });
        }
      } catch (e) {}
      var item = (j.items && j.items[0]) || j;
      var emit = function (cart) {
        try {
          document.dispatchEvent(new CustomEvent('tk-chat:cart-added', {
            detail: { variant_id: p.variant_id, handle: p.handle, item: item, cart: cart, sections: j.sections || null }
          }));
        } catch (e) {}
      };
      fetch(rootPath + '/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(emit, function () { emit(null); });
    }).catch(function (e) {
      btn.disabled = false;
      btn.textContent = label;
      btn.insertBefore(cartIcon(), btn.firstChild);
      // Hláška Shopify (třeba „vyprodáno") je v jazyce obchodu; chyba sítě má anglický
      // text prohlížeče, ta se zákazníkovi neukazuje.
      var msg = e && e.fromShop ? e.message : '';
      box.appendChild(el('div', 'tk-chat__card-err', msg || txt('cart_error', 'Do košíku se to teď nepovedlo vložit. Jde to i na stránce produktu.')));
    });
  }

  function cardActions(p) {
    if (!p.in_stock || !p.url) return null;
    var box = el('div', 'tk-chat__card-actions');
    if (p.variant_id && /^\d+$/.test(String(p.variant_id))) {
      var btn = el('button', 'tk-chat__card-add', txt('add_to_cart', 'Do košíku'));
      btn.type = 'button';
      btn.insertBefore(cartIcon(), btn.firstChild);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart(p, btn, box);
      });
      box.appendChild(btn);
      return box;
    }
    if (Number(p.variants) > 1) {
      var pick = el('a', 'tk-chat__card-add tk-chat__card-add--ghost', txt('choose_variant', 'Vybrat variantu'));
      pick.href = p.url;
      box.appendChild(pick);
      return box;
    }
    return null;
  }

  function card(p) {
    var a = el('div', 'tk-chat__card');
    if (p.image) {
      var img = el('img', 'tk-chat__card-img');
      img.src = p.image + (p.image.indexOf('?') >= 0 ? '&' : '?') + 'width=160';
      img.alt = '';
      img.loading = 'lazy';
      img.width = 64;
      img.height = 64;
      a.appendChild(img);
    } else {
      a.appendChild(el('span', 'tk-chat__card-img'));
    }
    var body = el('div', 'tk-chat__card-body');
    var title = el('div', 'tk-chat__card-title');
    var cardLink = el('a', 'tk-chat__card-link', p.title || '');
    cardLink.href = p.url || '#';
    title.appendChild(cardLink);
    body.appendChild(title);
    var meta = el('div', 'tk-chat__card-meta');
    var price = formatPrice(p.price);
    var cmp = p.price && p.price.compare_at != null && p.price.min != null && Number(p.price.compare_at) > Number(p.price.min) ? Number(p.price.compare_at) : null;
    if (price) meta.appendChild(el('span', 'tk-chat__card-price', price));
    if (cmp) meta.appendChild(el('s', 'tk-chat__card-compare', formatAmount(cmp, p.price.currency || '')));
    var pct = p.price && p.price.discount_pct != null ? Math.round(Number(p.price.discount_pct)) : 0;
    if (cmp && pct > 0) meta.appendChild(el('span', 'tk-chat__card-badge', '-' + pct + ' %'));
    var units = p.in_stock && p.units_left != null ? Math.round(Number(p.units_left)) : 0;
    var supplier = p.in_stock && p.stock_mode === 'supplier';
    var stockText = p.in_stock ? ((supplier && strings.in_stock_supplier) || strings.in_stock || '') : (strings.out_of_stock || '');
    if (units > 0 && units <= 5) stockText = units === 1 ? (strings.units_left_one || stockText) : fill(strings.units_left || '', { n: units }) || stockText;
    meta.appendChild(el('span', 'tk-chat__card-stock' + (p.in_stock ? (units > 0 && units <= 5 ? ' tk-chat__card-stock--low' : (supplier ? ' tk-chat__card-stock--supplier' : '')) : ' tk-chat__card-stock--out'), stockText));
    body.appendChild(meta);
    var actions = cardActions(p);
    if (actions) body.appendChild(actions);
    a.appendChild(body);
    return a;
  }

  function link(label, url) {
    var a = el('a', null, label);
    a.href = url;
    if (url.indexOf(location.origin) !== 0) {
      a.target = '_blank';
      a.rel = 'noopener';
    }
    return a;
  }

  function inline(text) {
    var frag = document.createDocumentFragment();
    var re = /\*\*([^*]+)\*\*|\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)|(https?:\/\/[^\s<>"']+)/g;
    var last = 0;
    var m;
    while ((m = re.exec(text))) {
      if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
      if (m[1]) {
        frag.appendChild(el('strong', null, m[1]));
      } else if (m[3]) {
        frag.appendChild(link(m[2], m[3]));
      } else {
        var url = m[4].replace(/[.,;:!?)]+$/, '');
        var tail = m[4].slice(url.length);
        frag.appendChild(link(url, url));
        if (tail) frag.appendChild(document.createTextNode(tail));
      }
      last = re.lastIndex;
    }
    if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
    return frag;
  }

  function renderText(text, products) {
    var pieces = [];
    var lines = String(text || '').split('\n');
    var para = [];
    var listEl = null;
    var byHandle = {};
    (products || []).forEach(function (p) { if (p && p.handle) byHandle[p.handle] = p; });

    function flushPara() {
      if (para.length) {
        var p = el('p');
        p.appendChild(inline(para.join(' ')));
        pieces.push({ node: p });
        para = [];
      }
    }

    function flushList() {
      if (listEl) { pieces.push({ node: listEl }); listEl = null; }
    }

    lines.forEach(function (raw) {
      var line = raw.trim();
      // Servisní řádky modelu (návrhy otázek, záměr zprávy): server je z finální odpovědi
      // vyjme, ale v průběžném streamu by na chvíli byly vidět.
      if (/^\[\[?\s*(next|intent)\s*:/i.test(line)) return;
      var mark = /^\[\[product:([a-z0-9-]+)\]\]$/i.exec(line);
      if (mark) {
        flushPara();
        flushList();
        var p = byHandle[mark[1].toLowerCase()];
        if (p) pieces.push({ card: p });
        return;
      }
      if (!line) { flushPara(); flushList(); return; }
      var li = /^(?:([-*•])|(\d+)[.)])\s+(.*)$/.exec(line);
      if (li) {
        flushPara();
        var tag = li[2] ? 'ol' : 'ul';
        if (listEl && listEl.tagName.toLowerCase() !== tag) flushList();
        if (!listEl) listEl = el(tag);
        var item = el('li');
        item.appendChild(inline(li[3]));
        listEl.appendChild(item);
        return;
      }
      flushList();
      para.push(line.replace(/\[\[product:[a-z0-9-]+\]\]/gi, '').trim());
    });
    flushPara();
    flushList();
    return pieces;
  }

  function addMessage(role, text, products, opts) {
    opts = opts || {};
    var cls = 'tk-chat__msg tk-chat__msg--' + (role === 'user' ? 'user' : 'bot');
    var wrap = opts.into || el('div', cls);
    if (opts.into) {
      wrap.className = cls;
      wrap.innerHTML = '';
    }
    if (role === 'user') {
      wrap.appendChild(el('div', 'tk-chat__bubble', text));
    } else {
      var pieces = renderText(text, products);
      var bubble = null;
      pieces.forEach(function (piece) {
        if (piece.card) {
          bubble = null;
          wrap.appendChild(card(piece.card));
        } else {
          if (!bubble) { bubble = el('div', 'tk-chat__bubble'); wrap.appendChild(bubble); }
          bubble.appendChild(piece.node);
        }
      });
      if (!wrap.childNodes.length) wrap.appendChild(el('div', 'tk-chat__bubble', text || ''));
    }
    if (!opts.into) log.appendChild(wrap);
    if (!opts.silent) scrollDown();
    return wrap;
  }

  function addError(msg, retryText) {
    var wrap = el('div', 'tk-chat__msg tk-chat__msg--bot');
    var bubble = el('div', 'tk-chat__bubble tk-chat__bubble--error', msg);
    if (retryText) {
      var btn = el('button', 'tk-chat__retry', strings.retry || 'Retry');
      btn.type = 'button';
      btn.addEventListener('click', function () {
        wrap.remove();
        send(retryText, true);
      });
      bubble.appendChild(btn);
    }
    wrap.appendChild(bubble);
    log.appendChild(wrap);
    scrollDown();
  }

  function addNote(text, silent) {
    log.appendChild(el('div', 'tk-chat__note', text));
    if (!silent) scrollDown();
  }

  function showTyping(label) {
    hideTyping();
    typingEl = el('div', 'tk-chat__msg tk-chat__msg--bot');
    var t = el('div', 'tk-chat__bubble tk-chat__typing');
    t.setAttribute('aria-label', strings.typing || '');
    t.appendChild(el('i'));
    t.appendChild(el('i'));
    t.appendChild(el('i'));
    t.appendChild(el('span', 'tk-chat__typing-label', label || ''));
    typingEl.appendChild(t);
    log.appendChild(typingEl);
    scrollDown();
  }

  function setTypingLabel(label) {
    if (!typingEl) { showTyping(label); return; }
    var l = typingEl.querySelector('.tk-chat__typing-label');
    if (l) l.textContent = label || '';
  }

  function nearBottom() {
    return log.scrollHeight - log.scrollTop - log.clientHeight < 200;
  }

  function readStream(r, current) {
    var reader = r.body.getReader();
    var dec = new TextDecoder();
    var buf = '';
    var pending = '';
    var live = null;
    var result = null;
    var ended = false;
    var lastDelta = 0;
    var gap = 600;

    function wordsIn(text) {
      return text.trim().split(/\s+/).filter(Boolean).length;
    }

    function firstWordsEnd(text, n) {
      var re = /\S+\s*/g;
      var m;
      var count = 0;
      var idx = 0;
      while ((m = re.exec(text))) {
        idx = re.lastIndex;
        count += 1;
        if (count >= n) break;
      }
      return idx;
    }

    function noteDelta() {
      var now = performance.now();
      if (lastDelta) gap = gap * 0.7 + Math.min(3000, now - lastDelta) * 0.3;
      lastDelta = now;
    }

    function paint() {
      if (!live) return;
      var stick = nearBottom();
      var shown = live.text.slice(0, live.shown);
      var open = shown.lastIndexOf('[[');
      if (open >= 0 && shown.indexOf(']]', open) < 0) shown = shown.slice(0, open);
      else if (shown.charAt(shown.length - 1) === '[') shown = shown.slice(0, -1);
      live.bubble.innerHTML = '';
      renderText(shown, []).forEach(function (p) { if (p.node) live.bubble.appendChild(p.node); });
      if (stick) log.scrollTop = log.scrollHeight;
      updateDown();
    }

    function tick(ts) {
      if (!live) return;
      var dt = live.last ? Math.min(50, ts - live.last) : 16;
      live.last = ts;
      var backlog = live.text.length - live.shown;
      if (backlog > 0) {
        var drain = live.flushing ? 250 : Math.min(2500, Math.max(900, gap * 1.5));
        var perMs = Math.max(live.flushing ? 0.6 : 0.045, backlog / drain);
        live.acc += perMs * dt;
        var step = Math.floor(live.acc);
        if (step > 0) {
          live.acc -= step;
          live.shown = Math.min(live.text.length, live.shown + step);
          paint();
        }
      }
      if (live.flushing && live.shown >= live.text.length) {
        if (live.onFlushed) live.onFlushed();
        return;
      }
      live.raf = requestAnimationFrame(tick);
    }

    function startLive(text, shown) {
      hideTyping();
      log.style.scrollBehavior = 'auto';
      var wrap = el('div', 'tk-chat__msg tk-chat__msg--bot tk-chat__msg--live');
      var bubble = el('div', 'tk-chat__bubble');
      wrap.appendChild(bubble);
      log.appendChild(wrap);
      live = { wrap: wrap, bubble: bubble, text: text, shown: shown, acc: 0, last: 0, raf: 0, flushing: false, onFlushed: null };
      paint();
      live.raf = requestAnimationFrame(tick);
    }

    function dropLive() {
      if (live) {
        if (live.raf) cancelAnimationFrame(live.raf);
        live.wrap.remove();
        live = null;
      }
      pending = '';
    }

    function handle(evt) {
      if (!evt || !evt.type) return;
      if (evt.type === 'done' || evt.type === 'error') {
        result = evt;
        return;
      }
      if (conv !== current) return;
      if (evt.type === 'tool') {
        setTypingLabel(strings[TOOL_STATUS[evt.name] || ''] || '');
        scrollDown();
      } else if (evt.type === 'reset') {
        dropLive();
        lastDelta = 0;
        if (!typingEl) showTyping();
      } else if (evt.type === 'delta') {
        noteDelta();
        if (live) {
          live.text += evt.text || '';
          return;
        }
        pending += evt.text || '';
        if (wordsIn(pending) >= 4 || pending.length >= 48) startLive(pending, firstWordsEnd(pending, 4));
      }
    }

    function parse(chunk) {
      var data = '';
      chunk.split('\n').forEach(function (line) {
        if (line.indexOf('data:') === 0) data += line.slice(5).trim();
      });
      if (!data) return;
      try { handle(JSON.parse(data)); } catch (e) {}
    }

    return new Promise(function (resolve, reject) {
      function end() {
        if (ended) return;
        ended = true;
        var keep = null;
        if (live && result && result.ok && conv === current) {
          if (live.raf) cancelAnimationFrame(live.raf);
          keep = live.wrap;
          live = null;
          pending = '';
        } else {
          dropLive();
        }
        log.style.scrollBehavior = '';
        if (!result) { reject(new Error('stream')); return; }
        resolve({ status: result.ok ? 200 : 500, data: result, streamed: true, wrap: keep });
      }
      function finish() {
        if (live && result && result.ok && conv === current && live.shown < live.text.length) {
          live.flushing = true;
          var timer = setTimeout(end, 700);
          live.onFlushed = function () { clearTimeout(timer); end(); };
          return;
        }
        end();
      }
      function pump() {
        reader.read().then(function (res) {
          if (res.done) {
            if (buf.trim()) parse(buf);
            finish();
            return;
          }
          buf += dec.decode(res.value, { stream: true });
          var parts = buf.split('\n\n');
          buf = parts.pop();
          parts.forEach(parse);
          if (result) { finish(); reader.cancel().catch(function () {}); return; }
          pump();
        }).catch(function () {
          if (result) finish(); else end();
        });
      }
      pump();
    });
  }

  function hideTyping() {
    if (typingEl) { typingEl.remove(); typingEl = null; }
  }

  function showRating(silent) {
    if (rateEl) rateEl.remove();
    rateEl = el('div', 'tk-chat__rate');
    rateEl.appendChild(el('span', null, strings.rate_question || ''));
    [[1, strings.rate_up, 'M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.3a2 2 0 0 0 2-1.7l1.4-9a2 2 0 0 0-2-2.3H14zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3'],
      [-1, strings.rate_down, 'M10 15v4a3 3 0 0 0 3 3l4-9V2H5.7a2 2 0 0 0-2 1.7l-1.4 9a2 2 0 0 0 2 2.3H10zM17 2h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-3']
    ].forEach(function (def) {
      var b = el('button');
      b.type = 'button';
      b.setAttribute('aria-label', def[1] || '');
      b.title = def[1] || '';
      b.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + def[2] + '"/></svg>';
      b.addEventListener('click', function () {
        rate(def[0]);
        rateEl.querySelectorAll('button').forEach(function (x) { x.classList.remove('is-active'); x.disabled = true; });
        b.classList.add('is-active');
        rateEl.firstChild.textContent = strings.rate_thanks || '';
      });
      rateEl.appendChild(b);
    });
    log.appendChild(rateEl);
    if (!silent) scrollDown();
  }

  function rate(value) {
    if (!conv) return;
    fetch(endpoint + '/rating', {
      method: 'POST', credentials: 'omit',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ shop: shop, session: conv.id, rating: value, locale: locale })
    }).catch(function () {});
  }

  function chipRow(keys, silent) {
    var chips = el('div', 'tk-chat__chips');
    var seen = {};
    keys.forEach(function (k) {
      var text = strings[k];
      if (!text || seen[text]) return;
      seen[text] = true;
      var b = el('button', 'tk-chat__chip', text);
      b.type = 'button';
      b.addEventListener('click', function () {
        chips.remove();
        send(text, false, FAQ_FOLLOW[k] || null);
      });
      chips.appendChild(b);
    });
    if (!chips.childNodes.length) return;
    log.appendChild(chips);
    if (!silent) scrollDown();
  }

  function showSuggestions() {
    chipRow(['suggest_1', 'suggest_2', 'suggest_3']);
  }

  function cleanSuggestions(list) {
    return (Array.isArray(list) ? list : [])
      .map(function (t) { return String(t || '').trim(); })
      .filter(function (t, i, arr) { return t && t.length <= 120 && arr.indexOf(t) === i; })
      .slice(0, 3);
  }

  function chipTexts(texts, silent) {
    var chips = el('div', 'tk-chat__chips');
    texts.forEach(function (text) {
      var b = el('button', 'tk-chat__chip', text);
      b.type = 'button';
      b.addEventListener('click', function () {
        chips.remove();
        send(text);
      });
      chips.appendChild(b);
    });
    if (!chips.childNodes.length) return;
    log.appendChild(chips);
    if (!silent) scrollDown();
  }

  function orderForm() {
    var chips = log.querySelector('.tk-chat__chips');
    if (chips) chips.remove();
    var wrap = el('div', 'tk-chat__msg tk-chat__msg--bot tk-chat__msg--form');
    var bubble = el('div', 'tk-chat__bubble tk-chat__bubble--form');
    bubble.appendChild(el('p', null, strings.order_intro || ''));
    var f = el('form', 'tk-chat__oform');
    f.noValidate = true;
    var num = el('input', 'tk-chat__oinput');
    num.type = 'text';
    num.name = 'order';
    num.autocomplete = 'off';
    num.placeholder = ORDER_PREFIX + '1234';
    num.setAttribute('aria-label', strings.order_number || '');
    var mail = el('input', 'tk-chat__oinput');
    mail.type = 'email';
    mail.name = 'email';
    mail.autocomplete = 'email';
    mail.placeholder = strings.order_email || 'E-mail';
    mail.setAttribute('aria-label', strings.order_email || '');
    var err = el('p', 'tk-chat__oerr', strings.order_error || '');
    err.hidden = true;
    var btn = el('button', 'tk-chat__obtn', strings.order_submit || '');
    btn.type = 'submit';
    f.appendChild(num);
    f.appendChild(mail);
    f.appendChild(err);
    f.appendChild(btn);
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var n = num.value.trim().toUpperCase().replace(/\s+/g, '').replace(/^#/, '');
      if (/^\d+$/.test(n)) n = ORDER_PREFIX + n;
      var em = mail.value.trim();
      var okNum = /^[A-Z]{0,4}\d{3,}$/.test(n);
      var okMail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em);
      err.hidden = okNum && okMail;
      num.classList.toggle('is-invalid', !okNum);
      mail.classList.toggle('is-invalid', !okMail);
      if (!okNum || !okMail) return;
      wrap.remove();
      send(fill(strings.order_message, { number: n, email: em }));
    });
    bubble.appendChild(f);
    wrap.appendChild(bubble);
    log.appendChild(wrap);
    scrollDown();
    if (window.matchMedia('(min-width: 750px)').matches) num.focus();
  }

  function contactRow(label, value, href, icon) {
    var row = el(href ? 'a' : 'div', 'tk-chat__crow');
    if (href) row.href = href;
    row.appendChild(svgIcon(icon, 18));
    var body = el('span', 'tk-chat__crow-body');
    body.appendChild(el('span', 'tk-chat__crow-label', label || ''));
    body.appendChild(el('span', 'tk-chat__crow-value', value));
    row.appendChild(body);
    return row;
  }

  function contactCard(silent) {
    var chips = log.querySelector('.tk-chat__chips');
    if (chips) chips.remove();
    var wrap = el('div', 'tk-chat__msg tk-chat__msg--bot tk-chat__msg--form');
    var bubble = el('div', 'tk-chat__bubble tk-chat__bubble--form tk-chat__contact');
    if (strings.human_intro) bubble.appendChild(el('p', null, strings.human_intro));
    var rows = el('div', 'tk-chat__crows');
    if (strings.human_email) rows.appendChild(contactRow(strings.human_email_label, strings.human_email, 'mailto:' + strings.human_email, ICONS.mail));
    if (strings.human_phone) rows.appendChild(contactRow(strings.human_phone_label, strings.human_phone, 'tel:' + strings.human_phone.replace(/[^\d+]/g, ''), ICONS.phone));
    if (strings.human_hours) rows.appendChild(contactRow(strings.human_hours_label, strings.human_hours, null, ICONS.clock));
    if (rows.childNodes.length) bubble.appendChild(rows);
    if (strings.human_form_url && strings.human_form) {
      var a = el('a', 'tk-chat__obtn tk-chat__obtn--link', strings.human_form);
      a.href = rootPath + strings.human_form_url;
      bubble.appendChild(a);
    }
    if (strings.human_note) bubble.appendChild(el('p', 'tk-chat__cnote', strings.human_note));
    wrap.appendChild(bubble);
    log.appendChild(wrap);
    if (!silent) scrollDown();
    return wrap;
  }

  function askHuman(text) {
    if (!conv) startNew();
    if (view !== 'chat') showView('chat');
    if (rateEl) { rateEl.remove(); rateEl = null; }
    toggleTray(false);
    if (text) {
      addMessage('user', text);
      conv.log.push({ r: 'u', t: text });
      if (!conv.title) conv.title = text;
    }
    contactCard();
    conv.log.push({ r: 'c' });
    conv.at = Date.now();
    conv.ended = false;
    if (!findConv(conv.id)) state.convs.push(conv);
    saveState();
    endBtn.hidden = false;
    pendingFollow = null;
    input.value = '';
    sessionSet(KEY_DRAFT, null);
    autosize();
  }

  function setSubtitle(c) {
    if (!subtitleEl) return;
    var mode = c && c.live ? c.live.mode : 'bot';
    if (mode === 'waiting') subtitleEl.textContent = strings.live_waiting || strings.subtitle || '';
    else if (mode === 'live') subtitleEl.textContent = (c.live.op ? fill(strings.live_with || '', { name: c.live.op }) : strings.live_operator) || strings.subtitle || '';
    else subtitleEl.textContent = strings.subtitle || '';
  }

  function applyLive(c, live) {
    var prev = c.live ? c.live.mode : 'bot';
    var mode = live && live.mode ? live.mode : 'bot';
    if (typeof live.total === 'number' && live.total > (c.seen || 0)) c.seen = live.total;
    c.live = mode === 'bot' ? null : { mode: mode, op: live.operator || null };
    saveState();
    if (conv === c) {
      setSubtitle(c);
      if (mode === 'waiting' && prev === 'bot') {
        if (strings.live_wait) { addNote(strings.live_wait, true); c.log.push({ r: 'n', t: strings.live_wait }); }
        if (strings.live_privacy) { addNote(strings.live_privacy, true); c.log.push({ r: 'n', t: strings.live_privacy }); }
        saveState();
        scrollDown();
      }
    }
    syncLivePoll();
  }

  function syncLivePoll() {
    var active = conv && conv.live;
    if (!active) {
      if (livePoll) { clearTimeout(livePoll); livePoll = null; }
      hideLiveTyping();
      return;
    }
    if (!livePoll) scheduleLivePoll(0);
  }

  function scheduleLivePoll(ms) {
    clearTimeout(livePoll);
    livePoll = setTimeout(livePollTick, ms);
  }

  function livePollTick() {
    var current = conv;
    if (!current || !current.live) { livePoll = null; return; }
    fetch(endpoint + '/live?shop=' + encodeURIComponent(shop) + '&session=' + encodeURIComponent(current.id)
      + '&since=' + (current.seen || 0) + '&locale=' + encodeURIComponent(locale), { credentials: 'omit', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (conv !== current || !current.live) return;
        if (d && d.ok) handleLive(current, d);
      })
      .catch(function () {})
      .then(function () {
        if (conv === current && current.live) scheduleLivePoll(root.classList.contains('is-open') ? LIVE_POLL : LIVE_POLL_HIDDEN);
        else livePoll = null;
      });
  }

  function handleLive(c, d) {
    var gotNew = false;
    (d.messages || []).forEach(function (m) {
      if (m.i < (c.seen || 0)) return;
      c.seen = m.i + 1;
      if (m.role === 'operator') {
        if (gotNew === false) hideLiveTyping();
        addOperator({ text: m.text, name: m.name || '' }, { silent: true });
        c.log.push({ r: 'o', t: m.text || '', n: m.name || '' });
        gotNew = true;
      } else if (m.role === 'note') {
        if (gotNew === false) hideLiveTyping();
        addNote(m.text, true);
        c.log.push({ r: 'n', t: m.text || '' });
        gotNew = true;
      }
    });
    if (typeof d.total === 'number' && d.total > (c.seen || 0)) c.seen = d.total;
    var mode = d.mode || 'bot';
    var prevMode = c.live ? c.live.mode : 'bot';
    c.live = mode === 'bot' ? null : { mode: mode, op: d.operator || null };
    if (mode === 'live' && d.typing) showLiveTyping(c.live.op || ''); else hideLiveTyping();
    if (gotNew) {
      c.at = Date.now();
      scrollDown();
      updateDown();
      if (!root.classList.contains('is-open')) setUnread(true);
    }
    if (mode !== prevMode || gotNew) { saveState(); setSubtitle(c); }
    if (mode === 'bot') syncLivePoll();
  }

  function addOperator(m, opts) {
    var wrap = el('div', 'tk-chat__msg tk-chat__msg--bot tk-chat__msg--op');
    var label = String(m.name || '').trim() || strings.live_operator || '';
    if (label) wrap.appendChild(el('div', 'tk-chat__opname', label));
    var bubble = el('div', 'tk-chat__bubble');
    renderText(m.text || '', []).forEach(function (p) { if (p.node) bubble.appendChild(p.node); });
    if (!bubble.childNodes.length) bubble.textContent = m.text || '';
    wrap.appendChild(bubble);
    log.appendChild(wrap);
    if (!(opts && opts.silent)) scrollDown();
    return wrap;
  }

  function showLiveTyping(name) {
    var label = fill(strings.live_typing || '', { name: name || strings.live_operator || '' });
    if (liveTypingEl) {
      var l = liveTypingEl.querySelector('.tk-chat__typing-label');
      if (l) l.textContent = label;
      return;
    }
    var stick = nearBottom();
    liveTypingEl = el('div', 'tk-chat__msg tk-chat__msg--bot tk-chat__msg--op');
    var t = el('div', 'tk-chat__bubble tk-chat__typing');
    t.setAttribute('aria-label', label);
    t.appendChild(el('i'));
    t.appendChild(el('i'));
    t.appendChild(el('i'));
    t.appendChild(el('span', 'tk-chat__typing-label', label));
    liveTypingEl.appendChild(t);
    log.appendChild(liveTypingEl);
    if (stick) scrollDown();
  }

  function hideLiveTyping() {
    if (liveTypingEl) { liveTypingEl.remove(); liveTypingEl = null; }
  }

  function queueTyping() {
    clearTimeout(liveTypingTimer);
    liveTypingTimer = setTimeout(sendTyping, TYPING_DELAY);
  }

  function sendTyping() {
    if (!conv || !conv.live) return;
    var text = input.value || '';
    if (text === lastTypingSent) return;
    lastTypingSent = text;
    fetch(endpoint + '/typing', {
      method: 'POST', credentials: 'omit',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ shop: shop, session: conv.id, text: text.slice(0, 600), locale: locale })
    }).catch(function () {});
  }

  function endLiveOnServer(c) {
    c.live = null;
    fetch(endpoint + '/live/end', {
      method: 'POST', credentials: 'omit',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ shop: shop, session: c.id, locale: locale })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d && d.note) {
        c.log.push({ r: 'n', t: d.note });
        if (typeof d.total === 'number' && d.total > (c.seen || 0)) c.seen = d.total;
        saveState();
      }
    }).catch(function () {});
  }

  function routeHuman(text, follow) {
    fetch(endpoint + '/live/available?shop=' + encodeURIComponent(shop), { credentials: 'omit', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.ok && d.live) send(text, false, follow, true);
        else askHuman(text);
      })
      .catch(function () { askHuman(text); });
  }

  function renderConversation() {
    log.innerHTML = '';
    rateEl = null;
    liveTypingEl = null;
    hideTyping();
    if (!conv.log.length) {
      addMessage('assistant', welcomeText(), [], { silent: true });
      showSuggestions();
    } else {
      conv.log.forEach(function (m) {
        if (m.r === 'c') { contactCard(true); return; }
        if (m.r === 'o') { addOperator({ text: m.t, name: m.n || '' }, { silent: true }); return; }
        if (m.r === 'n') { addNote(m.t, true); return; }
        addMessage(m.r === 'u' ? 'user' : 'assistant', m.t, m.p || [], { silent: true });
      });
      var lastMsg = conv.log[conv.log.length - 1];
      if (lastMsg && lastMsg.r === 'a' && !conv.ended && !conv.live) {
        var lastSugg = cleanSuggestions(lastMsg.s);
        if (lastSugg.length) chipTexts(lastSugg, true);
      }
    }
    setSubtitle(conv);
    endBtn.hidden = !conv.log.length;
    scrollDown(true);
    updateDown();
  }

  function previewText(c) {
    var last = c.log.length ? c.log[c.log.length - 1] : null;
    if (!last || !last.t) return '';
    return String(last.t)
      .replace(/\[\[product:[^\]]+\]\]/g, '')
      .replace(/\*\*/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function convItem(c, rich) {
    var b = el('button', 'tk-chat__item' + (rich ? ' tk-chat__item--last' : ''));
    b.type = 'button';
    var body = el('span', 'tk-chat__item-body');
    var title = el('span', 'tk-chat__item-title', c.title || firstUserText(c.log) || (strings.list_untitled || ''));
    var meta = el('span', 'tk-chat__item-meta', formatDate(c.at) + (c.ended ? ' · ' + (strings.ended || '') : ''));
    body.appendChild(title);
    if (rich) {
      var p = previewText(c);
      if (p) body.appendChild(el('span', 'tk-chat__item-preview', p));
    }
    body.appendChild(meta);
    b.appendChild(body);
    if (rich) b.appendChild(svgIcon('M9 6l6 6-6 6', 18));
    b.addEventListener('click', function () { openConv(c); });
    return b;
  }

  function renderList() {
    list.innerHTML = '';
    if (!state.convs.length) {
      list.appendChild(el('p', 'tk-chat__list-empty', strings.list_empty || ''));
      return;
    }
    state.convs.forEach(function (c) { list.appendChild(convItem(c)); });
  }

  function tile(id, label, hint, icon, onClick, wide) {
    var b = el('button', 'tk-chat__tile' + (wide ? ' tk-chat__tile--wide' : ''));
    b.type = 'button';
    b.dataset.tile = id;
    b.appendChild(svgIcon(icon));
    var body = el('span', 'tk-chat__tile-body');
    body.appendChild(el('span', 'tk-chat__tile-label', label));
    if (hint) body.appendChild(el('span', 'tk-chat__tile-hint', hint));
    b.appendChild(body);
    b.addEventListener('click', onClick);
    return b;
  }

  function renderHome() {
    ctxBox.innerHTML = '';
    var ctxTile = null;
    if (page.type === 'product' && page.title) {
      ctxTile = tile('product', strings.ctx_product || '', page.title, ICONS.product, function () {
        startNew();
        prefill(fill(strings.ctx_product_q, { title: page.title }));
      }, true);
      if (page.image) {
        var img = el('img', 'tk-chat__tile-img');
        img.src = page.image;
        img.alt = '';
        img.width = 40;
        img.height = 40;
        ctxTile.replaceChild(img, ctxTile.firstChild);
      }
    } else if (page.type === 'collection' && page.title) {
      ctxTile = tile('collection', strings.ctx_collection || '', page.title, ICONS.collection, function () {
        startNew();
        send(fill(strings.ctx_collection_q, { title: page.title }), false, ['faq_1', 'faq_2', 'faq_3']);
      }, true);
    }
    ctxBox.hidden = !ctxTile;
    if (ctxTile) ctxBox.appendChild(ctxTile);

    if (!tilesBox.childNodes.length) {
      TILES.forEach(function (t) {
        var label = strings['tile_' + t.id];
        if (!label) return;
        tilesBox.appendChild(tile(t.id, label, strings['tile_' + t.id + '_hint'] || '', ICONS[t.id], function () {
          startNew();
          if (t.form) orderForm();
          else if (t.human) routeHuman(strings.human_q || label);
          else send(strings[t.q], false, t.follow);
        }, t.wide));
      });
    }

    if (!faqBox.childNodes.length) {
      FAQ.forEach(function (k) {
        if (!strings[k]) return;
        var b = el('button', 'tk-chat__faq-item');
        b.type = 'button';
        b.appendChild(el('span', null, strings[k]));
        b.appendChild(svgIcon('M9 6l6 6-6 6', 16));
        b.addEventListener('click', function () {
          startNew();
          send(strings[k], false, FAQ_FOLLOW[k] || null);
        });
        faqBox.appendChild(b);
      });
    }

    recentList.innerHTML = '';
    var recent = state.convs.filter(function (c) { return c.log.length; }).slice(0, RECENT);
    recentBox.hidden = !recent.length;
    recent.forEach(function (c, i) { recentList.appendChild(convItem(c, i === 0)); });
    allBtn.hidden = state.convs.length <= RECENT;
    root.dataset.history = recent.length ? '1' : '0';
    setFaq(faqOpen === null ? !recent.length : faqOpen);
  }

  function setFaq(open) {
    faqBox.hidden = !open;
    faqToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function renderTray() {
    tray.innerHTML = '';
    var keys = FAQ.concat(['tile_returns_q', 'tile_discreet_q', 'tile_care_q']);
    keys.forEach(function (k) {
      if (!strings[k]) return;
      var b = el('button', 'tk-chat__chip', strings[k]);
      b.type = 'button';
      b.addEventListener('click', function () {
        toggleTray(false);
        if (!conv) startNew();
        send(strings[k], false, FAQ_FOLLOW[k] || null);
      });
      tray.appendChild(b);
    });
    if (strings.human_q) {
      var h = el('button', 'tk-chat__chip tk-chat__chip--human', strings.human_q);
      h.type = 'button';
      h.addEventListener('click', function () {
        toggleTray(false);
        routeHuman(strings.human_q);
      });
      tray.appendChild(h);
    }
  }

  function toggleTray(force) {
    var open = typeof force === 'boolean' ? force : tray.hidden;
    if (open && !tray.childNodes.length) renderTray();
    tray.hidden = !open;
    trayBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    trayBtn.classList.toggle('is-active', open);
  }

  function showView(name) {
    view = name;
    root.dataset.view = name;
    Object.keys(views).forEach(function (k) { views[k].hidden = k !== name; });
    backBtn.hidden = name === 'home';
    if (name !== 'chat') toggleTray(false);
    if (name === 'list') renderList();
    if (name === 'home') {
      renderHome();
      views.home.scrollTop = 0;
    }
  }

  function openConv(c) {
    conv = c;
    state.active = c.id;
    saveState();
    renderConversation();
    syncLivePoll();
    showView('chat');
    scrollDown(true);
    requestAnimationFrame(function () {
      scrollDown(true);
      updateDown();
      if (window.matchMedia('(min-width: 750px)').matches) input.focus();
    });
  }

  function startNew() {
    openConv(newConv());
  }

  function endConv() {
    if (conv && conv.live) endLiveOnServer(conv);
    if (conv && conv.log.length) {
      conv.ended = true;
      conv.at = Date.now();
      if (!findConv(conv.id)) state.convs.push(conv);
    }
    conv = null;
    state.active = null;
    saveState();
    syncLivePoll();
    setSubtitle(null);
    showView('home');
  }

  function goHome() {
    conv = null;
    state.active = null;
    saveState();
    syncLivePoll();
    setSubtitle(null);
    showView('home');
  }

  function prefill(text) {
    input.value = text || '';
    autosize();
    input.focus();
    try { input.setSelectionRange(input.value.length, input.value.length); } catch (e) {}
  }

  function setSending(v) {
    sending = v;
    sendBtn.disabled = v;
    input.disabled = v;
  }

  function setUnread(on) {
    badge.hidden = !on;
    launch.classList.toggle('has-unread', on);
  }

  var EMOTICONS = [
    [/(^|\s)(?::-?\)|=\)|:\]|\(:)(?=$|\s|[.,!?])/g, '🙂'],
    [/(^|\s)(?::-?D|=D|xD|XD)(?=$|\s|[.,!?])/g, '😄'],
    [/(^|\s)(?:;-?\)|;\])(?=$|\s|[.,!?])/g, '😉'],
    [/(^|\s)(?::-?\(|=\(|:\[)(?=$|\s|[.,!?])/g, '🙁'],
    [/(^|\s)(?::-?[Pp])(?=$|\s|[.,!?])/g, '😛'],
    [/(^|\s)(?::-?[Oo])(?=$|\s|[.,!?])/g, '😮'],
    [/(^|\s)(?::-?\*)(?=$|\s|[.,!?])/g, '😘'],
    [/(^|\s)(?::-?\/)(?=$|\s|[.,!?])/g, '😕'],
    [/(^|\s)(?::'-?\()(?=$|\s|[.,!?])/g, '😢'],
    [/(^|\s)<3(?=$|\s|[.,!?])/g, '❤️'],
    [/(^|\s)\^\^(?=$|\s|[.,!?])/g, '😊']
  ];

  function emojify(text) {
    var out = text;
    EMOTICONS.forEach(function (pair) {
      out = out.replace(pair[0], function (m, pre) { return pre + pair[1]; });
    });
    return out;
  }

  function send(text, isRetry, follow, direct) {
    text = emojify(String(text || '').trim());
    if (!text || sending) return;
    if (!isRetry && !direct && !(conv && conv.live) && isHumanRequest(text)) { routeHuman(text, follow); return; }
    if (!conv) startNew();
    if (view !== 'chat') showView('chat');
    var chips = log.querySelector('.tk-chat__chips');
    if (chips) chips.remove();
    if (rateEl) { rateEl.remove(); rateEl = null; }
    toggleTray(false);
    var current = conv;
    if (!isRetry) {
      addMessage('user', text);
      current.log.push({ r: 'u', t: text });
      if (!current.title) current.title = text;
      current.at = Date.now();
      current.ended = false;
      if (!findConv(current.id)) state.convs.push(current);
      saveState();
      endBtn.hidden = false;
      pendingFollow = follow || null;
    }
    input.value = '';
    sessionSet(KEY_DRAFT, null);
    autosize();
    setSending(true);
    clearTimeout(liveTypingTimer);
    lastTypingSent = '';
    if (!current.live) showTyping();

    var attempt = function (force) {
      return ensureToken(force).then(function (tok) {
        return fetch(endpoint, {
          method: 'POST', credentials: 'omit',
          headers: { 'Content-Type': 'application/json', Accept: 'text/event-stream, application/json' },
          body: JSON.stringify({
            shop: shop, session: current.id, message: text, locale: locale, country: country,
            root_url: rootUrl, page: page, hp_check: form.hp_check ? form.hp_check.value : '', challenge: tok,
            stream: canStream, live: 1, widget: TK_CHAT_VERSION
          })
        });
      }).then(function (r) {
        var ct = r.headers.get('content-type') || '';
        if (r.status === 200 && ct.indexOf('text/event-stream') >= 0 && r.body && r.body.getReader) return readStream(r, current);
        return r.json().then(function (d) { return { status: r.status, data: d || {} }; });
      });
    };

    attempt(false).then(function (res) {
      if (res.status === 403 && res.data.code === 'challenge') return attempt(true);
      return res;
    }).then(function (res) {
      hideTyping();
      setSending(false);
      var d = res.data;
      if (res.status === 200 && d.ok && d.live && d.reply == null) {
        current.at = Date.now();
        applyLive(current, d.live);
        if (conv === current && root.classList.contains('is-open')) input.focus();
        return;
      }
      if (res.status === 200 && d.ok) {
        var sugg = d.handoff ? [] : cleanSuggestions(d.suggestions);
        current.log.push({ r: 'a', t: d.reply || '', p: (d.products || []).slice(0, 4), s: sugg });
        current.at = Date.now();
        saveState();
        if (conv === current) {
          var stick = res.streamed && nearBottom();
          var reply = addMessage('assistant', d.reply || '', d.products || [], { silent: true, into: res.wrap || null });
          if (!d.live && d.handoff && strings.handoff_note) addNote(strings.handoff_note, true);
          showRating(true);
          if (sugg.length) chipTexts(sugg, true);
          else if (pendingFollow && !d.handoff) chipRow(pendingFollow, true);
          pendingFollow = null;
          if (res.streamed) { if (stick) scrollDown(); }
          else scrollToStart(reply);
          updateDown();
        }
        if (d.live) applyLive(current, d.live);
        if (!root.classList.contains('is-open')) setUnread(true);
      } else if (conv === current) {
        addError(d.error || strings.error_generic || 'Error', res.status >= 500 ? text : null);
      }
      if (conv === current && root.classList.contains('is-open')) input.focus();
    }).catch(function () {
      hideTyping();
      setSending(false);
      if (conv === current) addError(strings.error_network || 'Error', text);
    });
  }

  function autosize() {
    input.style.height = 'auto';
    var full = input.scrollHeight + 2;
    input.style.height = Math.min(120, full) + 'px';
    input.style.overflowY = full > 120 ? 'auto' : 'hidden';
  }

  function open(instant) {
    root.classList.add('is-open');
    document.body.classList.add('tk-chat-open');
    panel.hidden = false;
    launch.setAttribute('aria-expanded', 'true');
    launch.setAttribute('aria-label', strings.close || '');
    store(KEY_OPEN, '1');
    setUnread(false);
    cancelNudge();
    if (instant) {
      panel.style.transition = 'none';
      requestAnimationFrame(function () { panel.style.transition = ''; });
    }
    var active = state.active ? findConv(state.active) : null;
    if (active) openConv(active);
    else showView('home');
    var draft = sessionGet(KEY_DRAFT);
    if (draft && !input.value) { input.value = draft; autosize(); }
    fetchToken().catch(function () {});
  }

  function close() {
    root.classList.remove('is-open');
    document.body.classList.remove('tk-chat-open');
    launch.setAttribute('aria-expanded', 'false');
    launch.setAttribute('aria-label', strings.open || '');
    store(KEY_OPEN, null);
    setTimeout(function () { if (!root.classList.contains('is-open')) panel.hidden = true; }, 230);
    launch.focus();
  }

  function ask(text, sendNow) {
    if (!root.classList.contains('is-open')) open(false);
    if (!text) return;
    if (sendNow) {
      if (!conv || conv.ended) startNew();
      send(text);
    } else {
      if (!conv) startNew();
      else if (view !== 'chat') showView('chat');
      prefill(text);
    }
  }

  function applyAddress(form) {
    if (form !== 'informal' && form !== 'formal') form = addressForm;
    addressForm = form;
    root.dataset.address = form;
    if (form === 'informal') {
      Object.keys(strings).forEach(function (k) {
        if (/_i$/.test(k) && strings[k]) strings[k.slice(0, -2)] = strings[k];
      });
    }
    var intro = root.querySelector('[data-tk-chat-intro]');
    if (intro && strings.home_intro) intro.textContent = strings.home_intro;
    var foot = root.querySelector('[data-tk-chat-foot]');
    if (foot && strings.disclaimer) foot.textContent = strings.disclaimer;
    var tt = root.querySelector('[data-tk-chat-tiles-title]');
    if (tt && strings.tiles_title) tt.textContent = strings.tiles_title;
  }

  function applyName(name) {
    var current = root.dataset.name || '';
    if (!name || name === current) return;
    var title = root.querySelector('#tk-chat-title');
    if (title) title.textContent = name;
    if (current) {
      ['welcome', 'welcome_1', 'welcome_2', 'welcome_3', 'welcome_4', 'home_intro'].forEach(function (k) {
        if (strings[k]) strings[k] = strings[k].split(current).join(name);
      });
      var intro = root.querySelector('[data-tk-chat-intro]');
      if (intro && strings.home_intro) intro.textContent = strings.home_intro;
    }
    root.dataset.name = name;
  }

  function deepLink() {
    var h = location.hash || '';
    var m = /^#chat(?:=(.*))?$/.exec(h);
    if (!m) {
      var q = /[?&]chat=([^&]*)/.exec(location.search);
      if (!q) return false;
      m = [null, q[1] === 'open' || q[1] === '1' ? '' : q[1]];
    }
    var text = '';
    try { text = decodeURIComponent(m[1] || '').replace(/\+/g, ' '); } catch (e) {}
    open(false);
    if (text) ask(text, false);
    if (location.hash === h && h) {
      try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
    }
    return true;
  }

  // Aktivní oslovení: config z /status ({delay, pages}). Počítá se jen čas s viditelnou
  // záložkou a zavřeným chatem; bublina nejvýš jednou za návštěvu, křížek ji odloží na
  // 3 dny a během živého chatu s kolegou se neukáže.
  function nudgeAllowed() {
    if (root.classList.contains('is-open') || sessionGet(KEY_NUDGE_SEEN)) return false;
    var off = Number(load(KEY_NUDGE_OFF) || 0);
    if (off && Date.now() - off < NUDGE_SNOOZE) return false;
    for (var i = 0; i < state.convs.length; i++) if (state.convs[i].live) return false;
    return true;
  }

  // ?chat_nudge=test: náhled pro provozovatele, bublina po 5 s na jakékoli stránce bez
  // ohledu na pravidla výš.
  function setupNudge(cfg) {
    var test = /[?&]chat_nudge=test(&|$)/.test(location.search);
    if (test) cfg = { delay: 5, pages: [page.type || 'other'] };
    if (!cfg || !Array.isArray(cfg.pages) || cfg.pages.indexOf(page.type || 'other') < 0) return;
    if (!test && !nudgeAllowed()) return;
    var left = Math.max(5, Number(cfg.delay) || 60);
    nudgeTimer = setInterval(function () {
      if (document.visibilityState === 'hidden' || root.classList.contains('is-open')) return;
      if (--left > 0) return;
      clearInterval(nudgeTimer);
      nudgeTimer = null;
      if (test || nudgeAllowed()) showNudge();
    }, 1000);
  }

  function showNudge() {
    sessionSet(KEY_NUDGE_SEEN, '1');
    var title = txt('nudge_title', 'Potřebujete poradit?');
    var line = page.type === 'product'
      ? txt('nudge_product', 'Zeptejte se na cokoli k tomuto produktu, odpovím hned.')
      : txt('nudge_other', 'Pomůžu vám s výběrem, stačí se zeptat.');
    nudgeEl = el('div', 'tk-chat__nudge');
    var body = el('button', 'tk-chat__nudge-body');
    body.type = 'button';
    body.appendChild(el('span', 'tk-chat__nudge-title', title));
    if (line) body.appendChild(el('span', 'tk-chat__nudge-text', line));
    body.addEventListener('click', function () { open(false); });
    var x = el('button', 'tk-chat__nudge-close');
    x.type = 'button';
    x.setAttribute('aria-label', txt('nudge_close', 'Zavřít'));
    x.appendChild(svgIcon('M18 6 6 18M6 6l12 12', 14));
    x.addEventListener('click', function () {
      store(KEY_NUDGE_OFF, String(Date.now()));
      cancelNudge();
      launch.focus();
    });
    nudgeEl.appendChild(body);
    nudgeEl.appendChild(x);
    root.appendChild(nudgeEl);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { if (nudgeEl) nudgeEl.classList.add('is-in'); });
    });
  }

  function cancelNudge() {
    if (nudgeTimer) {
      clearInterval(nudgeTimer);
      nudgeTimer = null;
      sessionSet(KEY_NUDGE_SEEN, '1');
    }
    if (nudgeEl) {
      if (nudgeEl.parentNode) nudgeEl.parentNode.removeChild(nudgeEl);
      nudgeEl = null;
    }
  }

  function boot(name, address, nudge) {
    applyAddress(address || addressForm);
    applyName(name);
    loadState();
    root.hidden = false;
    var activeLive = state.active ? findConv(state.active) : null;
    if (activeLive && activeLive.live) { conv = activeLive; syncLivePoll(); }
    launch.addEventListener('click', function () {
      if (root.classList.contains('is-open')) close();
      else open(false);
    });
    closeBtn.addEventListener('click', close);
    backBtn.addEventListener('click', goHome);
    endBtn.addEventListener('click', endConv);
    allBtn.addEventListener('click', function () { showView('list'); });
    faqToggle.addEventListener('click', function () {
      faqOpen = faqBox.hidden;
      setFaq(faqOpen);
    });
    trayBtn.addEventListener('click', function () { toggleTray(); });
    downBtn.addEventListener('click', scrollDown);
    log.addEventListener('scroll', updateDown, { passive: true });
    log.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || !log.contains(a) || a.target === '_blank') return;
      store(KEY_OPEN, null);
    });
    Array.prototype.forEach.call(newBtns, function (b) { b.addEventListener('click', startNew); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      send(input.value);
    });
    input.addEventListener('input', function () {
      autosize();
      sessionSet(KEY_DRAFT, input.value || null);
      if (conv && conv.live) queueTyping();
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        send(input.value);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) {
        if (!tray.hidden) toggleTray(false);
        else close();
      }
    });
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-tk-chat-ask]') : null;
      if (!t || root.contains(t)) return;
      e.preventDefault();
      ask(t.getAttribute('data-tk-chat-ask') || '', t.getAttribute('data-tk-chat-send') === '1');
    });
    window.tkChat = {
      open: function () { open(false); },
      close: close,
      ask: ask,
      isOpen: function () { return root.classList.contains('is-open'); }
    };
    if (!deepLink() && load(KEY_OPEN) === '1') open(true);
    setupNudge(nudge);
  }

  function checkStatus() {
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(KEY_STATUS) || 'null'); } catch (e) {}
    if (cached && Date.now() - cached.at < STATUS_TTL) {
      if (cached.on) boot(cached.name || '', cached.address || '', cached.nudge || null);
      return;
    }
    fetch(endpoint + '/status?shop=' + encodeURIComponent(shop), { credentials: 'omit', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var on = !!(d && d.ok && d.enabled);
        var name = on && typeof d.name === 'string' ? d.name.trim() : '';
        var address = on && (d.address === 'informal' || d.address === 'formal') ? d.address : '';
        var nudge = on && d.nudge && typeof d.nudge === 'object' ? d.nudge : null;
        try { sessionStorage.setItem(KEY_STATUS, JSON.stringify({ at: Date.now(), on: on, name: name, address: address, nudge: nudge })); } catch (e) {}
        if (on) boot(name, address, nudge);
      })
      .catch(function () {});
  }

  if (!endpoint || !shop) return;
  if ('requestIdleCallback' in window) requestIdleCallback(checkStatus, { timeout: 3000 });
  else setTimeout(checkStatus, 1500);
})();
